
import '../../scss/common.scss';
import "./breadCrums.scss";
import { useNavigate } from "react-router-dom";
type items = {
  name: string;
  onClickNavigateTo: string;
  color: string;
};
type IObjectType = {
  name: string; onClickNavigateTo: string; color: string;
}
const Bredcrums = ({ breadCrumbData }: any) => {
  
  const navigate = useNavigate();

  const onClickMethod = (receivedObject: IObjectType) => {
    navigate(receivedObject.onClickNavigateTo, { replace: true });
  };
  return (
    <div className="breadcrums_main_wrapper">
        {breadCrumbData.map((element: items) => (
          <span key={element.name} style={{ color: element.color }} onClick={() => onClickMethod(element)}>
            {element.name}
          </span>
        ))}
    </div>
  );
};
export default Bredcrums;
